import { Sidebar } from './Sidebar';
import { HelpButton } from '../HelpButton';
import { OnboardingBanner } from '../onboarding/OnboardingBanner';

export const DashboardLayout = ({ children }) => {
    return (
        <div className="dashboard-layout min-h-screen bg-background">
            <Sidebar />
            <main className="flex-1 overflow-y-auto overflow-x-hidden">
                <div className="p-4 md:p-6 lg:p-8 pt-16 md:pt-6">
                    <OnboardingBanner />
                    {children}
                </div>
            </main>
            <HelpButton />
        </div>
    );
};
